import clsx from 'clsx';

export function Spinner({
  size = 'md',
  className,
}: {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'border-2 border-surface-4 border-t-brand rounded-full animate-spin',
        { 'w-4 h-4': size === 'sm', 'w-6 h-6': size === 'md', 'w-10 h-10': size === 'lg' },
        className,
      )}
    />
  );
}

export function LoadingScreen({ message = 'Loading...' }: { message?: string }) {
  return (
    <div className="flex flex-col items-center justify-center h-64 gap-4">
      <Spinner size="lg" />
      <p className="text-gray-500 text-sm">{message}</p>
    </div>
  );
}
